// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useLedgerEnd } from '@hooks/queries/ledger/useLedgerEnd';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AppRewardConfiguration } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Configuration/AppReward';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';

export const useAppRewardConfiguration: () => UseQueryResult<
  TemplateContract<AppRewardConfiguration>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const offset = useLedgerEnd();
  const { operator } = useParties();
  return useQuery({
    queryKey: ['queryAppRewardConfiguration', ledgerApi, offset, operator],
    queryFn: async () => {
      return ledgerApi.queryAppRewardConfiguration(offset!, operator);
    },
    refetchInterval: false,
  });
};
